import { render, staticRenderFns } from "./abIcon.vue?vue&type=template&id=19409cb9&"
import script from "./abIcon.vue?vue&type=script&lang=js&"
export * from "./abIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports